<!--ПОЛНЫЙ ЭКРАН-->
<div *ngIf="isFullscreen"
     [@fullScreen]="'in'"
     [class.active]="isFullscreen"
     class="full_screen">
    <app-file-toolbar
            (approveEmit)="onLoadFileDataApproved()"
            (deleteEmit)="deleteEmit.emit()"
            (newVersionEmit)="updateFile($event)"
            [controller]="toolbarController"
            [currentMemberSigner]="currentMemberSigner"
            [currentMember]="currentMember"
            [currentVersion]="currentVersion"
            [fileModel]="fileModel"
            [fullscreen]="isFullscreen"
            [isImSign]="isImSign"

            [isOpenModal]="isOpenModal"
            [lockSignButton]="lockSignButton"
            [right]="right"
    ></app-file-toolbar>
    <div class="row w-auto"
         style="background: #fff; height: 100%">
        <div class="col-9"
             style="height: 100%">
            <ng-container
                    *ngTemplateOutlet="fileVersionError ? errorTemplate : fileVersionJob ? warningTemplate : fileIFrame"
            ></ng-container>
        </div>
        <div class="col-3 right_sidebar">
            <app-signers
                    (updateEvent)="onLoadFileData()"
                    [editPermission]="right.is_edit_signer"
                    [fileModel]="fileModel"
                    [permissions]="right"
                    [signers]="signers"
            ></app-signers>
            <app-visors
                    (updateApproveEvent)="onLoadFileDataApproved()"
                    (updateEvent)="onLoadFileData()"
                    [editPermission]="right.is_edit_approver"
                    [fileKey]="fileModel.key"
                    [fileModel]="fileModel"
                    [permissions]="right"
            ></app-visors>
            <h2 class="mt-3">{{ 'DOCUMENTS.TEXT.INFO' | translate }}</h2>
            <app-detail-property (refreshEmit)="onLoadFileData()"
                                 *ngIf="fileModel"
                                 [canEdit]="right.is_edit_property"
                                 [customProperties]="fileModel.custom_properties"
                                 [targetKey]="fileModel.key"

                                 [target]="'file'"
            ></app-detail-property>
        </div>
    </div>
</div>
    <mat-dialog-actions>
      <mat-icon svgIcon="close-line" mat-dialog-close style="width: 20px;"></mat-icon>
    </mat-dialog-actions>

<div (dragenter)="dragenter($event)"
     (dragover)="dragover($event)"
     class="page-content">
    <app-file-toolbar
            (approveEmit)="onLoadFileDataApproved()"
            (deleteEmit)="deleteEmit.emit()"
            (newVersionEmit)="updateFile($event)"
            (updateEvent)="onInit()"
            [controller]="toolbarController"
            [currentMemberSigner]="currentMemberSigner"
            [currentMember]="currentMember"
            [currentVersion]="currentVersion"
            [fileModel]="fileModel"
            [fullscreen]="isFullscreen"

            [isImSign]="isImSign"
            [isOpenModal]="isOpenModal"
            [lockSignButton]="lockSignButton"
            [right]="right"
    ></app-file-toolbar>
    <ng-container
            *ngTemplateOutlet="fileVersionError ? errorTemplate : fileVersionJob ? warningTemplate : fileIFrame"></ng-container>
</div>

<ng-template #fileIFrame>
    <app-component-loading *ngIf="!isLoading"></app-component-loading>
    <div *ngIf="fileModel && isLoading"
         class=""
         style="height: inherit">
        <div (drop)="drop($event)"
             *ngIf="isShowDropArea"
             class="drop_file_area">
            <h1><i class="bi bi-arrow-down-square-fill"></i> {{ 'DOCUMENTS.TEXT.DRAG' | translate }}</h1>
        </div>
        <div *ngIf="isShowHoverDiv && !isShowDropArea"
             class="drop_file_area"
             style="opacity: 0">
            <h1><i class="bi bi-arrow-down-square-fill"></i> {{ 'DOCUMENTS.TEXT.DRAG' | translate }}</h1>
        </div>

        <ng2-pdfjs-viewer (onDocumentLoad)="allPages = $event; lockSignButton = $event !== 1"
                          (onPageChange)="checkPages($event)"
                          *ngIf="virtualCurrentFileUrl && isLoadingCurrentVersion && currentVersion.status !== 'error'"
                          [openFile]="false"
                          [pdfSrc]="virtualCurrentFileUrl"
                          [zoom]="zoomExt"
                          style="background: #525659; height: inherit;"
                          viewerId="MyUniqueID"
        ></ng2-pdfjs-viewer>
    </div>
</ng-template>

<ng-template #errorTemplate>
    <div class="alert alert-danger">
        <h2 [innerHTML]="'DOCUMENTS.TEXT.ERROR' | translate"></h2>
    </div>
</ng-template>
<ng-template #warningTemplate>
    <div class="alert alert-warning">
        <h2>{{ 'DOCUMENTS.TEXT.PROCESS' | translate }}</h2>
    </div>
</ng-template>
